import styled from 'styled-components';
import React, { JSX } from 'react';
import NoDataImg from '../assets/no-data.svg';
import { StyledBlueHeading } from './styled/styles';
import { Typography } from '@dls/react-core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
`;

interface NoDataMessageProps {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
}

export const NoDataMessage: React.FC<NoDataMessageProps> = ({ title, subtitle }) => {
  return (
    <Container>
      <img src={NoDataImg} style={{ margin: 24 }} width={120} alt="No data icon" />
      <StyledBlueHeading variant="h3" style={{ fontWeight: 500 }}>
        {title}
      </StyledBlueHeading>
      {subtitle && (
        <Typography
          variant="body2"
          color="secondary"
          style={{ textAlign: 'center', marginTop: 8, lineHeight: 1.75 }}
        >
          {subtitle}
        </Typography>
      )}
    </Container>
  );
};
